<template>
    <CommonBox title="Bind Learning System Account" @close="$emit('close')" @submit="submit">
        <el-form ref="form" label-position="top" :model="form" :rules="rules">
            <el-form-item label="Email of learning system:" prop="Email">
                <el-input v-model="form.Email"></el-input>
            </el-form-item> 

            <el-form-item label="Password of learning system:" prop="Password">
                <el-input v-model="form.Password" type="password" autocomplete="new-password"></el-input>
            </el-form-item> 
        </el-form>
    </CommonBox>
</template>
<script>
import CommonBox from "@/components/common/CommonBox.vue";
export default {
    components:{
        CommonBox
    },
    data () {
        return {
            form:{
                Email:"",
                Password:"",
                Type:'learning'
            },
            rules:{
                Email:[{ required: true, message: 'Please input the email address', trigger: 'blur' }],
                Password:[{required: true, message: 'Please enter a password', trigger: 'blur'}]
            }
        };
    },
    methods:{
        submit () {
            this.$refs.form.validate((valid) => {
                if(!valid) return false;
                this.$http.post('bindOtherSys',this.form,(data)=>{
                    this.$baseNotice.message(data.msg);
                    this.$emit('close');
                    this.$emit('update');
                });
            });
        }
    }
};
</script>

<style lang="less" scoped>
    
</style>